import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { FaArrowRight } from 'react-icons/fa';
import { cta, ctaSm, ctaAccent, curveBg, ctaBtn, arrowIcon } from './cta.module.scss';

const CtaBusinessSm1 = ({ primaryEventId }) => {
    return (
        <Link
            to="/"
            className={`${cta} ${ctaSm} ${ctaAccent} icon-animate-bounce`}
            id={ primaryEventId }>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1223.67 852.18"
                height="100%"
                width="100%"
                className={curveBg}
                preserveAspectRatio="none"
                role="presentation">
                <path
                    height="100%"
                    width="100%"
                    d="M1223.67,0c-130.69,3.15-217,72.67-253.23,148.1-37.05,77.2-123.52,134.33-205.35,134.33S579.81,351.91,547.38,401.32s-89.55,145.14-245.5,145.14C163.22,546.46,28.22,796.71,0,852.18H1223.67Z"></path>
            </svg>
            <div className="text-center">
                <strong className={`eyebrow text-secondary`}>Spend less time doing payroll.</strong>
                <span className={`text-xs`}>
                    Run accurate payrolls with PaycheckCity Payroll. <br className="hide-on-lg"/>Autocomplete your calculations and forms.
                </span>
                <div className={`${ctaBtn} btn btn-secondary btn-sm margin-top-xs`}>
                    See how it works
                    <i className={`${arrowIcon} align-icon`}>
                        <FaArrowRight />
                    </i>
                </div>
            </div>
        </Link>
    );
};

CtaBusinessSm1.propTypes = {
    primaryEventId: PropTypes.string.isRequired,
};

export default CtaBusinessSm1;
